<div class="container-fluid p-3 p-md-4" style="max-width: 1200px">
  <!-- Hero Banner -->
  <div class="booking-hero card border-0 mb-4">
    <div class="booking-hero__content">
      <div>
        <div class="booking-hero__eyebrow">Patient Medical Record</div>
        <h2 class="booking-hero__title mb-1">Consultation & Medical History</h2>
        <p class="booking-hero__meta mb-0">
          Review previous diagnoses, prescriptions, and practitioner notes.
        </p>
      </div>
      <div class="booking-hero__status">
        <span
          class="badge bg-primary-subtle text-primary border border-primary-subtle rounded-pill px-3 py-2"
        >
          {{ history.length }} Consultation{{ history.length === 1 ? '' : 's' }}
        </span>
      </div>
    </div>
  </div>

  @if (isLoading) {
    <div class="loader-overlay" role="status" aria-live="polite">
      <div class="heart-wrapper" aria-hidden="true">
        <svg class="heart-svg" viewBox="0 0 24 24">
          <path
            class="heart-shape"
            d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 6 4 4 6.5 4 8.24 4 9.91 5 10.54 6.36
               11.17 5 12.76 4 14.5 4 17 4 19 6 19 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
          />
          <polyline class="ekg" points="3 12 7 12 9 8 11 15 13 6 15 12 21 12" fill="none" />
        </svg>
      </div>
      <p class="loader-text mt-3 fw-semibold text-dark">Loading medical history...</p>
    </div>
  }

  @if (!isLoading && history.length === 0) {
    <div class="empty-state">
      <i class="bi bi-clock-history fs-1 d-block mb-2 text-primary"></i>
      <h5>No Medical History Found</h5>
      <p class="text-muted small">
        No past consultations or medical records recorded yet for this patient.
      </p>
    </div>
  }

  @if (!isLoading && history.length > 0) {
    <div class="d-flex flex-column gap-3">
      @for (item of history; track item.bookingId) {
        <div class="card booking-card">
          <div class="card-header booking-card__header">
            <div>
              <div class="booking-card__eyebrow">Consultation Ref: {{ item.reference }}</div>
              <h4 class="sub-title mb-0">{{ item.reasonForVisit || 'Medical Visit' }}</h4>
            </div>

            <span class="status-pill status-confirmed">{{ item.status }}</span>
          </div>

          <div class="card-body p-3">
            <div class="detail-matrix mb-3">
              <div class="detail-chip">
                <span class="detail-chip__label">Date & Time</span>
                <span class="detail-chip__value"
                  >{{ item.bookingDate | date: 'dd MMM yyyy' }} at {{ item.bookingTime }}</span
                >
              </div>

              <div class="detail-chip">
                <span class="detail-chip__label">Diagnosis</span>
                <span class="detail-chip__value text-primary fw-bold">{{
                  item.diagnosisOfTheDay || '—'
                }}</span>
              </div>
            </div>

            @if (item.doctorNotes) {
              <div class="notes-card notes-card--soft mb-3">
                <span class="notes-card__label">Doctor Notes</span>
                <p class="notes-card__body mb-0">{{ item.doctorNotes }}</p>
              </div>
            }

            @if (!!item.doctorNotesFiles && item.doctorNotesFiles.length > 0) {
              <div class="attachment-section">
                <span class="detail-chip__label mb-2">Attached Documents</span>
                <div class="d-flex flex-wrap gap-2">
                  @for (file of item.doctorNotesFiles; track file) {
                    <a
                      [href]="file"
                      target="_blank"
                      rel="noopener"
                      class="btn btn-sm btn-outline-primary"
                    >
                      <i class="bi bi-file-earmark-arrow-down me-1"></i>Download Attachment
                    </a>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
